import { render, staticRenderFns } from "./comBasicInfo.vue?vue&type=template&id=3de870e1&scoped=true&"
import script from "./comBasicInfo.vue?vue&type=script&lang=js&"
export * from "./comBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./comBasicInfo.vue?vue&type=style&index=0&id=3de870e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de870e1",
  null
  
)

export default component.exports